import * as Common from './common';
import * as Create from './create';
import * as List from './list';
import * as PartAssignment from './partAssignment';
import * as TasksAssignment from './tasksAssignment';
import * as Invoice from './invoice';

const Actions = {
  ...Common,
  ...Create,
  ...List,
  ...Invoice,
  ...PartAssignment,
  ...TasksAssignment,
};

export default Actions;
